import type { kit as en } from "../en/kit";
import type { Messages } from "../types";

export const kit: Messages<typeof en> = {
  more: "المزيد",
  advanced: "خيارات متقدمة",
  technicalDetails: "تفاصيل تقنية",
  filters: "التصفية",
  clearFilters: "مسح التصفية",
  activeFilters: "التصفية المطبّقة",
  removeFilter: "إزالة التصفية: {{label}}",
  search: "بحث",
  selected_zero: "تم تحديد {{count}}",
  selected_one: "تم تحديد {{count}}",
  selected_two: "تم تحديد {{count}}",
  selected_few: "تم تحديد {{count}}",
  selected_many: "تم تحديد {{count}}",
  selected_other: "تم تحديد {{count}}",
  clearSelection: "إلغاء التحديد",
  bulkActions: "إجراءات للعناصر المحددة",
  noMatches: "لا شيء يطابق هذه التصفية",
  noMatchesHint: "جرّب تصفية أخرى، أو امسح التصفية لعرض كل شيء.",
  loading: "جارٍ التحميل…",
  openFullPage: "فتح الصفحة كاملة",
  close: "إغلاق",
  undo: "تراجع",
  undone: "تم التراجع",
  undoFailed: "تعذّر التراجع. حاول مرة أخرى.",
  density: {
    label: "الكثافة",
    comfortable: "مريحة",
    compact: "مضغوطة",
  },
};
